import {Controller} from '@hotwired/stimulus';
import Axios from '../axios';

export default class extends Controller {

    static targets() {
        return ['list', 'filters', 'active-filters', 'load-btn'];
    }

    connect() {
        this.isScrollRunning = false;
        this.boundingClientRect = this.element.getBoundingClientRect();
        this.currentLanguageCode = document.documentElement.lang.split('-')[0];
        this.filters = {};

        this.type = this.element.dataset.type;
        this.from = this.element.dataset.from ? this.element.dataset.from : 0;
        this.limit = this.element.dataset.limit ? this.element.dataset.limit : 6;
        this.total = this.element.dataset.total ? this.element.dataset.total : -1;

        this.handleFilters();

        if (this.element.dataset.filter) {
            this.filters = JSON.parse(this.element.dataset.filter);
        }

        const btn = this.targets.find('load-btn');
        if (btn) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.isScrollRunning = true;
                this.fetchPosts().then(response => {
                    if (response && response.data) {
                        this.insertContent(response.data);
                        this.from = response.from;
                        this.total = response.total;
                        this.isScrollRunning = false;

                        if (this.total === this.from) {
                            btn.classList.add('hidden');
                        } else {
                            btn.classList.remove('hidden');
                        }
                    }
                });
            });

            if (this.total === this.from) {
                btn.classList.add('hidden');
            } else {
                btn.classList.remove('hidden');
            }
        }
    }

    disconnect() {
        this.boundingClientRect = '';
    }

    handleFilters() {
        const postFilters = this.targets.find('filters');
        if (postFilters) {
            let timeout = 0;
            postFilters.querySelectorAll('.single-filter').forEach((btn) => {
                btn.addEventListener('click', () => {
                    const name = btn.getAttribute('data-taxonomy');
                    this.filters[name] = btn.getAttribute('data-value');

                    postFilters.querySelectorAll('.single-filter').forEach((btn2) => {
                        btn2.classList.remove('filter-active');
                    });

                    btn.classList.add('filter-active');

                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        this.from = 0;
                        this.fetchPosts().then(response => {
                            if (response && response.data) {
                                this.emptyContent();
                                this.insertContent(response.data);
                                this.from = response.from;
                                this.total = response.total;
                                this.isScrollRunning = false;

                                const btn = this.targets.find('load-btn');
                                if (btn) {
                                    if (this.total === this.from) {
                                        btn.classList.add('hidden');
                                    } else {
                                        btn.classList.remove('hidden');
                                    }
                                }
                            }
                        });
                    }, 800);
                });
            });
        }
    }

    onScroll() {
        this.boundingClientRect = this.element.getBoundingClientRect();

        if (!this.isScrollRunning && window.scrollY >= this.boundingClientRect.top) {
            this.isScrollRunning = true;

            this.fetchPosts().then(response => {
                if (response && response.data && response.total) {
                    this.insertContent(response.data);
                    this.from = response.from;
                    this.total = response.total;
                    this.isScrollRunning = false;
                }
            });
        }
    }

    scrollToElement() {
        //this.element.lastElementChild.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }

    async fetchPosts() {
        if (parseInt(this.from) >= parseInt(this.total) && parseInt(this.total) > 0) {
            return '';
        }

        this.element.classList.add('loading');

        const data = {
            rest_language: this.currentLanguageCode,
            from: this.from,
            limit: this.limit,
            filters: JSON.stringify(this.filters),
        };

        const params = Object.keys(data).map(function (k) {
            return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
        }).join('&');

        let response = null;
        try {
            response = await Axios.get(`/etna/api/${this.type}/?${params}`);
            response = response.data.data;
        } catch (error) {
            response = error.response.data.data;
        }

        this.element.classList.remove('loading');

        return response;
    }

    emptyContent() {
        const list = this.targets.find('list');
        if (list) {
            list.innerHTML = '';
        } else {
            this.element.innerHTML = '';
        }
    }

    insertContent(html) {
        const list = this.targets.find('list');
        if (list) {
            list.insertAdjacentHTML('beforeend', html);
        } else {
            this.element.insertAdjacentHTML('beforeend', html);
        }
    }
}
